window.tabsHandler = () => {
  let initializedSlickState = false;

  document.addEventListener('DOMContentLoaded', () => {
    // initializeInfinite()
    switchActiveTab();
    tabsPanelStickyOutside();
    fitTabsBarToContainer();
  });

  window.addEventListener('resize', () => {
    fitTabsBarToContainer();
  });

  const fitTabsBarToContainer = () => {
    const tabsContainers = document.querySelectorAll('.jsTabsControl');

    tabsContainers && tabsContainers.forEach(container => {
      const fitTabsToContainer = container.classList.contains('jsTabsFitToContainer');

      if (fitTabsToContainer) {
        const containerWidth = container.clientWidth;
        const fittedClassName = 'tabs__tabs-control-wrapper--fitted';
        const tabs = container.querySelectorAll('.jsTab');
        const tabsWrapper = container.querySelector('.jsTabsWrapper');
        const tabsWrapperIsFitted = tabsWrapper.classList.contains(fittedClassName);
        let tabsWidth = 0;

        // If tabs wrapper contains style class, remove before counting tabs width
        tabsWrapperIsFitted && tabsWrapper.classList.remove(fittedClassName);

        // Count tabs width
        tabs && tabs.forEach(tab => {
          const tabWidth = tab.offsetWidth;

          tabsWidth += tabWidth;
        });

        // if container is wider than tabs width, fit tabs to container
        if (containerWidth > tabsWidth) {
          tabsWrapper.classList.add(fittedClassName);
        }
        else {
          tabsWrapper.classList.remove(fittedClassName);
        }
      }
    });
  };

  const initializeInfinite = () => {
    if (typeof Waypoint === 'function') {
      alert('wchodzi!')
      new Waypoint.Infinite({
        element: $('.jsTabCaseStudiesBox')[0],
        onAfterPageLoad: () => {
          renderProgressiveImages(true);
          window.lazyLoad?.update();
        }
      });
    }
  };

  const initializeSlickEvents = (tab) => {
    if (!initializedSlickState) {
      tab.classList.remove('jsTabInitializeSlick');
      window.productCategoriesHandler();
      initializedSlickState = true;
    }
  };

  const setActiveTabEVents = (container, tabsControls, currentTab, currentTabIdx, scroll = false) => {
    const initializeSlick = currentTab.classList.contains('jsTabInitializeSlick');
    const param = currentTab.getAttribute("data-param");

    window.queryParamEvents("set", "tab", param);
    setActiveTabControl(tabsControls, currentTabIdx);
    setActiveTabPanel(container, currentTabIdx);
    initializeSlick && initializeSlickEvents(currentTab);

    if (scroll) {
      const headerNav = document.querySelector('.jsHeaderNav');
      const header = headerNav.querySelector('.header');
      const headerHeight = header.getBoundingClientRect().height;

      scrollToDest(container, headerHeight * (-1));
    }
  };

  const setActiveTabPanel = (container, currentTabIdx) => {
    const tabsPanelWrapper = container.querySelector('.jsTabsPanelWrapper');
    const tabsPanel = tabsPanelWrapper.querySelectorAll('.jsTabPanel');

    tabsPanel && tabsPanel.forEach((tabPanel, tabPanelIdx) => {
      currentTabIdx === tabPanelIdx
        ? slideDown(tabPanel)
        : slideUp(tabPanel);
    });
  };

  const setActiveTabControl = (tabsControlContainers, currentTabIdx) => {
    const activeClass = 'tabs__tab-control--active';

    tabsControlContainers.forEach(tabsControlContainer => {
      const tabs = tabsControlContainer.querySelectorAll('.jsTab');

      // Set current tab as active (for sticky and fixed tabs)
      tabs.forEach((tab, tabIdx) => {
        currentTabIdx === tabIdx
          ? tab.classList.add(activeClass)
          : tab.classList.remove(activeClass);
      });
    });
  }

  const switchActiveTab = () => {
    const customActiveTabAfterPageIsLoaded = window.queryParamEvents("get", "tab");
    const tabsContainers = document.querySelectorAll('.jsTabsContainer');

    // All Tabs Modules
    tabsContainers && tabsContainers.forEach(container => {
      const tabsControls = container.querySelectorAll('.jsTabsControl');

      // All Tabs controls in tab module
      tabsControls && tabsControls.forEach((tabControl, tabControlIdx) => {
        const tabs = tabControl.querySelectorAll('.jsTab');

        // Current tab as active
        tabs && tabs.forEach((currentTab, currentTabIdx) => {
          const paramAttr = currentTab.getAttribute("data-param");

          // Set custom active tab when page is loaded (without scroll)
          if (customActiveTabAfterPageIsLoaded && customActiveTabAfterPageIsLoaded === paramAttr) {
            // Run only once
            tabControlIdx === 0 && setActiveTabEVents(container, tabsControls, currentTab, currentTabIdx);
          }

          // Set active tab and scroll to them after click on tab control
          currentTab.addEventListener('click', () => {
            setActiveTabEVents(container, tabsControls, currentTab, currentTabIdx, true);
          });
        });
      });
    });
  };

  const tabsPanelStickyOutside = () => {
    const tabsContainers = document.querySelectorAll('.jsTabsContainer');

    tabsContainers && tabsContainers.forEach(container => {
      const tabsControl = container.querySelector('.jsTabsControl');

      window.addEventListener('scroll', () => {
        const controlPositionDetails = tabsControl.getBoundingClientRect();
        const controlTopPosition = controlPositionDetails.top;
        const controlHeight = controlPositionDetails.height;
        const containerPositionType = controlTopPosition < -controlHeight ? 'fixed' : 'sticky';

        container.setAttribute('data-position', containerPositionType)
      });
    });
  };
};
